import axiosClient from "../common/axios/axiosConfig";
import { showToast } from "../utils/showToast";

export interface IProfessionalProfile {
	ative: boolean;
	biografia: string;
	codu: number;
	nome: string;
	numeroRegistro: string;
	estadoRegistro: string;
	especialidade: string;
	subespecialidade: string[];
	registro: string;
	imagem: string;
	numeroConselho: string;
	conselho: string;
	avaliacao: number;
	contagemAvaliacao: number;
	procedimentos: Array<{ id: string; description: string }>;
	convenios: Array<{ id: string; description: string }>;
}

export const getProfessional = (codProfessional: string): Promise<IProfessionalProfile> => {
	return axiosClient
		.get<IProfessionalProfile>(`/buscar-profissional/${codProfessional}`)
		.then(response => {
			return response.data;
		})
		.catch(() => {
			showToast("error", {
				text: "Erro ao buscar informações do profissional",
			});
			return {} as IProfessionalProfile;
		});
};
